<template>

  <div  clearfix class="clearfix main_center" >

    <div class="content">
      <!--Video-->
      <div class="videoPlayerWrapper" :style="{height:videoHeight + 'px'}">
        <hlsPlayer ref="videoPlayerRef"
                   :videoUrl.sync="videoUrl"
                   :keyIframeOffset.sync="keyIframeOffset"
                   :camDOMid="'camDOMid' + Math.random()"
                   :poster="require('@/assets/images/video_empty.jpg')">
        </hlsPlayer>
        <placeAndEquipment
                ref="placeAndEquipmentRef"
                :showSrcSwitch="true"
                roomType="1"
                :videoSwitchData.sync="videoSrcData"
                @switchCurrentVideo="switchVideoUrl"></placeAndEquipment>
      </div>
      <!--form-->
      <el-form ref="form" :model="form"   label-width="100px" style="margin-top: 12px" class="form">
          <el-row :gutter="15">
            <el-col :span="20">
              <el-form-item label="关联项目：" prop='projectName' >
                <el-input v-model="displayName" disabled ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4" style="padding-top: 10px ">
              <el-checkbox v-model="form.dataGroup" :true-label="'1'" :false-label="'2'" disabled>按招标项目抽取</el-checkbox>
            </el-col>

          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="见证记录：" prop='witnessContent' >
                <el-input type="textarea" disabled :rows="3" v-model="form.witnessContent" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>


          <el-row>
            <el-col :span="12">
              <el-form-item label="见证人：" prop='witnessUserId' >
                <el-input  disabled  v-model="form.witnessUserName" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="记录关键帧："  >

                <el-table
                        :data="tableDataDetail"
                        border
                        v-loading="keyListLoading"
                        style="width: 100%">
                  <el-table-column
                          header-align="center"
                          label="序号"
                          width="50"
                          type="index"
                          align="center">
                  </el-table-column>
                  <el-table-column
                          header-align="center"
                          label="操作"
                          width="80"
                          align="center">
                    <template slot-scope="scope">
                      <el-button @click="confirmPosition(scope.row.timeDeviationSec,scope.$index)" type="text"  size="small">定位</el-button>
                    </template>
                  </el-table-column>
                  <el-table-column
                          prop="recordTime"
                          header-align="center"
                          label="时间"
                          width="90"
                          align="center">
                    <template scope="scope">
                      <span style="margin-left: 10px" >{{scope.row.recordTimeStr}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="快照" align="center" width='100'>
                    <template slot-scope="scope">
                      <img :src="scope.row.screenshotUrl" @click="showImgDialog(scope.row.screenshotUrl)" v-if="scope.row.screenshotUrl" class="thumbnail" alt="">
                    </template>
                  </el-table-column>
                  <el-table-column
                          prop="remark"
                          header-align="center"
                          label="备注">
                  </el-table-column>
                </el-table>

              </el-form-item>
            </el-col>

          </el-row>

        </el-form>
    </div>


    <el-dialog :visible.sync="imgDialogVisible" width="100%" height="100%" @closed="dialogClose">
      <img :src="dialogImageUrl" alt="" @contextmenu.prevent=""  class="viewImg">
    </el-dialog>

  </div>





</template>

<script>
    import videoPlayer from "@/components/videoPlayer/video";
    import hlsPlayer from "@/components/videoPlayer/hlsPlayer";
    import placeAndEquipment from "@/components/videoPlayer/placeAndEquipment";
    import {tabsCloseCurrentHandle} from '@/utils/routeTab';
    import {scrollToTop} from '@/utils/index';

    export default {
  components: {
    videoPlayer,
    hlsPlayer,
    placeAndEquipment
  },
  data(){
    return{

      imgDialogVisible:false,
      dialogImageUrl:"",
      currentVideo:{},
      videoSrcData:[],
      videoHeight:750,
      keyIframeOffset:[],
      // videoUrl:"rtmp://58.200.131.2:1935/livetv/cctv1",
      videoUrl:'',
      dateRange:[],//交易时间范围
      displayName:'',//页面展示的项目名称或标段名称
      form:{    //见证数据
        id: "",          //见证数据ID
        bidopenTime: "", //开标时间
        businessId: "",  //关联的项目ID
        businessexId: "",//关联的标段ID
        createTime: "",  //创建时间
        createUser: "",  //创建人
        dataGroup: "",   //是否关联项目  1:关联项目  2:关联标段
        dataType: "",    //见证类型     1专家抽取见证 2开标见证 3评标见证
        delFlag: false,
        detailList: [], //见证明细数据
        evalEtime: "",  //评标开始时间
        evalStime: "",  //评标结束时间
        field1: "",
        field2: "",
        field3: "",
        fileTypeDictCode: "",
        fileTypeMap: {},
        historyid: "",  //-1:暂存   0:已生效
        remark: "",     //备注
        updateTime: "", //更新时间
        updateUser: "", //更新用户
        videoEtime: "", //视频结束时间
        videoStime: "", //视频开始时间
        witnessContent: "",
        witnessUserId: "",
        witnessUserName:"",
        dataSource:"",
        project: {  //项目数据
          id: "",
          projectCode: "",   //项目编号
          projectName: "",   //项目名称
          tenderAgencyName: "", //招标代理机构名称
          tendererName:""   //招标人名称
        },
        bid:{ //标段数据
          id:'',
          bidCode: '',
          bidName:''
        },
      },
      tableDataDetail: [],
      keyListLoading:false,
    }


  },
  mounted() {
    this.videoHeight = document.documentElement.clientHeight<600?600:(document.documentElement.clientHeight-125);
  },
  computed:{

  },
  activated(){

    this.form.id = (this.$route.query && this.$route.query.id ) || '' ;
    this.form.dataSource = (this.$route.query && this.$route.query.dataSource ) || '' ;
    this.getDataById(this.id);

    this.$nextTick(() => {
      if(this.$refs.videoPlayerRef){
        this.$refs.videoPlayerRef.play(); // 播放
      }
    })



  },
  deactivated() {
    if(this.$refs.videoPlayerRef){
      this.$refs.videoPlayerRef.pause();  // 暂停
    }
  },
  methods:{

    //定位视频
    confirmPosition(timeDeviationSec) {

      this.$refs.videoPlayerRef.setCurrentTime(timeDeviationSec);
      scrollToTop()

    },



    dialogClose() {
      this.dialogImageUrl = "";
      this.imgDialogVisible = false;
    },
    // 图片放大弹窗
    showImgDialog(filePath){
      this.dialogImageUrl=filePath;
      this.imgDialogVisible = true;
    },

    switchVideoUrl(video){

      video.playUrl = video.playUrl?video.playUrl:'';
      video.leavel = video.deviceName || '';
      this.currentVideo = video;
      if(!this.currentVideo.playUrl){
        this.$message({
          type: 'error',
          message: '视频正在合成，请稍后刷新播放'
        })
      }
      this.videoUrl = this.currentVideo.playUrl || '';
      this.getKeyIframeList();


    },
    getKeyIframeList() { // 获取列表数据

      if(this.form.id && this.currentVideo.id){
        this.keyListLoading = true;
        this.$http.get(`/trading/tradingWitDetails/getByWitnessIdAndDeviceCode?witnessId=${this.form.id}&deviceCode=${this.currentVideo.id}&timeDeviation=${this.currentVideo.timeDeviation || 0}`,)
          .then(res=>{
            this.keyListLoading = false;
            if(res.data.code =="1"){
              this.tableDataDetail = res.data.data;
              const that = this;
              var timeOffSetArr = []
              this.tableDataDetail.forEach((item)=>{
                // item.screenshotUrl = this.$http.adornUrl(item.screenshotUrl)
                var timeDeviationSec = parseInt( (new Date(item.recordTime.replace(/-/g,"/")).getTime() - new Date(item.videoStime.replace(/-/g,"/")).getTime() )/1000 ) + (item.timeOffset?parseInt(item.timeOffset):0) ;
                if(timeDeviationSec >0){
                  item.timeDeviationSec = timeDeviationSec || 0;
                  timeOffSetArr.push(timeDeviationSec);
                  item.recordTimeStr=that.formatterTimeDeviation(timeDeviationSec);
                }else{
                  item.recordTimeStr = '-:-:-'
                }
              })
              this.keyIframeOffset = timeOffSetArr;
            }else{
              this.tableDataDetail = [];
            }

          })
      }

    },

    formatterTimeDeviation(timeDeviationSec){

      var hours = parseInt(timeDeviationSec  / 60 / 60 % 24 , 10);
      var minutes = parseInt(timeDeviationSec  / 60 % 60, 10);
      var seconds = parseInt(timeDeviationSec  % 60, 10);
      return (hours<10?('0'+hours):hours) + ":"+ (minutes<10?('0'+minutes):minutes) +':'+ (seconds<10?('0'+seconds):seconds);

    },

    backBtn(){ //返回
      tabsCloseCurrentHandle();
      this.clearData()
      this.$router.push({
        name:'expertWitness_list'
      })

    },

    getDataById(){ //详情

      if(this.form.id != ""){

        this.$http.get(`/tradding/traddingwitness/get?id=${this.form.id}&dataSource=${this.form.dataSource}`).then(res=>{
          if(res.data.code == '1'){
            const data = res.data.data;
            this.form={...data};
            this.form.dataGroup = this.form.dataGroup.toString();
            if (this.form.dataGroup == '1') {
              this.displayName = (data.project && data.project.projectName) || '';
              // 获取视频源
              this.getVideoUrlList(this.form.businessId,'project',1)
            }else{
              this.displayName = (data.bid && data.bid.bidName) || '';
              // 获取视频源
              this.getVideoUrlList(this.form.businessexId,'bid',1)
            }



          }
        })

      }

    },

    getVideoUrlList(id,bizType,roomType){

      // 查询场地及场地的摄像头
      this.$http.get(`/tradding/traddingwitness/getFieldsAndDevicePlayback?code=${id}&roomType=${roomType}&bizType=${bizType}`).then(res=>{
        if(res.data.code==='1'){

          this.videoSrcData = res.data.data;
          if(this.videoSrcData[0] && this.videoSrcData[0].devices && this.videoSrcData[0].devices[0]){
            const videoObj = JSON.parse(JSON.stringify(this.videoSrcData[0].devices[0]));
            videoObj.playUrl = videoObj.playUrl?videoObj.playUrl:"";
            videoObj.leavel = videoObj.deviceName?videoObj.deviceName:"";
            this.currentVideo=videoObj;
            if(!this.currentVideo.playUrl){
              this.$message({
                type: 'error',
                message: '视频正在合成，请稍后刷新播放'
              })
            }
            this.$refs.placeAndEquipmentRef.setCurrentVideo(this.currentVideo);
            this.getKeyIframeList()
          }
          this.videoUrl = this.currentVideo.playUrl || '';



        }else{
          this.videoSrcData = [];
          this.videoUrl=[];
        }
      })
    },

  },

}
</script>

<style lang="less" scoped>
  .viewImg{
    height: 100%;
    display: block;
    margin: 0 auto;
  }
.main_center{
  height: 100%;
  /deep/ .el-dialog__header{
    border-bottom: 0;
  }
  /deep/ .el-dialog__body{
    padding: 0 10px 20px 10px;
  }
  .content{

    .videoPlayerWrapper{
      width: 100%;height:750px;display: block;text-align: center;position: relative
    }

    .thumbnail{
      width: 50px;
      height: 50px;
    }

    .set_btn{
      float:right;
      margin-bottom:20px;
    }
    .more_btn{
      text-align: center;
    }
    .upload-demo{
      display: flex;
      height: 34px;
      border-bottom: 1px solid #dcdfe6;
      .el-button{
        position: absolute;
        right: 0;
      }
    }

  }
}

.backBtn{
  margin-right:10%;
}

</style>